import type { WithdrawSuccessResponse } from '@/shared/types';
import { apiClient, handleRequest } from '@/shared/api';
import { objectToQueryParamsStr } from '@/shared/utils';
import type { SbpBanksResponse, WithdrawSbpRequestFunction } from '../model';

export const getSbpBanks = async (
  paymentTypeCode: string
): Promise<SbpBanksResponse> => {
  const request = () =>
    apiClient.get<SbpBanksResponse>(
      `/operations/sbp/withdraw/banks?${objectToQueryParamsStr({ paymentTypeCode })}`
    );
  const response = await handleRequest<SbpBanksResponse>(request);
  return response.data;
};

export const withdrawSbp: WithdrawSbpRequestFunction = async body => {
  const response = await apiClient.post<WithdrawSuccessResponse>(
    '/operations/sbp/withdraw',
    body
  );
  return response.data;
};
